import * as S from './styles.ts';
import DynamicIcon from '@template/components/DynamicIcon';
import { IInputProps } from '@template/components/Input';
import Select from '@template/components/Select';
import { iconsArray } from '@template/icons';

const IconSelect = ({ ...props }: Partial<IInputProps>) => {
  return (
    <Select
      {...props}
      selected={props.selected || ''}
      label={props.label}
      onChange={props.onChange}
      search
      startContent={<DynamicIcon name={(props.selected as string) || ''} />}
      options={[
        {
          label: 'None',
          key: '',
        },
        ...iconsArray.map(({ key, label, value }: any) => ({
          label: label,
          key: key,
          render: (
            <S.IconOptionContainer>
              <S.IconContainer>{value({})}</S.IconContainer>
              {label}
            </S.IconOptionContainer>
          ),
        })),
      ]}
    />
  );
};

export default IconSelect;
